import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/store/authStore";
import {
  isMfaPassed,
  mfaRedirectPath,
  needsFactorStepUp,
} from "@/lib/auth/jwt";

interface MfaChallengeGuardProps {
  children: ReactNode;
}

export function MfaChallengeGuard({ children }: MfaChallengeGuardProps) {
  const accessToken = useAuthStore((state) => state.accessToken);

  if (!accessToken) {
    return <Navigate to="/login" replace />;
  }
  if (isMfaPassed(accessToken) && !needsFactorStepUp(accessToken)) {
    return <Navigate to="/" replace />;
  }
  const target = mfaRedirectPath(accessToken);
  if (target && target !== "/auth/mfa/challenge") {
    return <Navigate to={target} replace />;
  }
  return <>{children}</>;
}
